const getUtcDateTime = (date: Date | null = null) => {
  if(!date) {
    date = new Date();
  }
  return date.getUTCFullYear() + '-' + date.getUTCMonth() + '-' 
        + date.getUTCDate() + ' ' + date.getUTCHours() + ':' + date.getUTCMinutes()
        + ':' + date.getUTCSeconds();
}

export default getUtcDateTime;